export default __webpack_public_path__ + "static/media/notification.f2643bab.png";